/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M10.7 2c1-1.2 2.8-1.3 4-.3L37 21.8a3 3 0 0 1 0 4.4l-22.4 20c-1.1 1.1-2.9 1-4-.2a3 3 0 0 1 .4-4l20-18L11 6a3 3 0 0 1-.3-4z"/>'
  }
})
